// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1fuBK","search":"Settings_search__1RWDF","filter":"Settings_filter__1pcFG"};